import { ReactNode } from "react"
import { useOutletContext } from "react-router-dom"
import { ToolDef } from "../toolRegistry"

interface ToolShellProps {
  children: ReactNode
}

export default function ToolShell({ children }: ToolShellProps) {
  const { tool } = useOutletContext<{ tool: ToolDef }>()

  if (!tool) return <>{children}</>

  return (
    <div className="space-y-10">
      <header>
        <h1 className="text-3xl font-extrabold text-slate-900 tracking-tight sm:text-4xl">
          {tool.title}
        </h1>
        <p className="mt-4 text-lg text-slate-600 leading-relaxed max-w-3xl">
          {tool.description}
        </p>
      </header>

      {/* Calculator / Main Content */}
      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
        {children}
      </div>
    </div>
  )
}
